import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

/**
 * 检查是否能注销，并返回相应理由
 */
export function checkDelete() {
    return http
        .get<{
            cancelable: boolean;
            reason: string;
        }>(API.OAUTH.delete.checkCancel())
        .then(resp => resp.data || {});
}

/**
 * 查询注销状态
 */
export function getDeleteStatus() {
    return http.get<{ has_applied: boolean }>(API.OAUTH.delete.cancellation()).then(resp => resp.data?.has_applied);
}

/**
 * 提交注销请求/撤销注销申请
 * apply: 申请注销
 * revoke: 撤销申请
 */
export function applyOrRevokeDeleteApplication(type: 'apply' | 'revoke') {
    return http.post<{
        success: boolean;
        reasons: Array<{ content: string; title: string }>;
    }>(
        API.OAUTH.delete.apply(),
        {
            process: type
        },
        { useJson: true }
    );
}

/**
 * IB检查是否能提交关户，并返回相应理由
 */
export function checkIBClose() {
    return http
        .get<{
            reason: string;
            status: boolean;
        }>(API.CUSTOMER.close.checkClose(), {
            params: {
                customer_id: security.currentCustomerId
            }
        })
        .then(resp => resp.data || {});
}

/**
 * IB查询关闭帐户状态
 */
export function getIBCloseStatus() {
    return security.currentCustomerId
        ? http
              .get<{
                  close_content: string | null;
                  close_reason: string | null;
                  close_reject_reasons: string | null;
                  // PENDING, SUCCESS, REJECTED, REVOKING, REVOKE 如果用户未提交申请为null
                  close_status: 'REVOKE' | 'PENDING' | 'REJECTED' | 'REVOKING';
              }>(API.CUSTOMER.close.getCloseStatus(), {
                  params: {
                      customer_id: security.currentCustomerId,
                      application_type: 'close'
                  }
              })
              .then(resp => resp.data?.close_status)
        : Promise.resolve(null);
}

/**
 * IB提交关户申请
 */
export function applyIBSubmitClose() {
    return http.post(API.CUSTOMER.close.submitClose(), {
        customer_id: security.currentCustomerId
    });
}

/**
 * IB提交撤销关户申请
 */
export function deleteIBSubmitClose() {
    return http.put(API.CUSTOMER.close.deleteSubmitClose(), {
        customer_id: security.currentCustomerId
    });
}
